import React, {useContext, useState} from "react";
import importImg from './../../../assets/img/import-img.png'
import checkIcon from './../../../assets/img/check-icon.png'
import "./../../../styles/ImportGroup.scss";
import {useFormik} from "formik";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import RespondentService  from "../../shared/services/RespondentService";
import AppContext from "./AppContext";
import {ErrorParse} from "../handlers/ErrorParse";
import {useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next';


/**
 * It's a function that returns a div with a className of "ImportGroup" that contains a div with a
 * className of "ImportGroup-container" that contains a div with a className of "closeWindow" that
 * contains a div that contains an img that contains a div that contains a div that contains a h2 that
 * contains a p that contains a form that contains a span with a className of "p-float-label" that
 * contains an input with a type of "email" that contains a label that contains a div that contains an
 * input with a type of "submit" that contains a span that contains an a
 * @returns A component that renders a form with an email input and a submit button.
 */
export default function ImportGroup({showImportGroup}) {
    const myContext = useContext(AppContext);
    const [isSuccessInput , onSucessInput ] = useState(false);
    const [statusModal , onUpdateStatus ] = useState('initial');
    const navigate = useNavigate();
    const { t } = useTranslation();
    const formik = useFormik({
        initialValues: {
            email:  '',
            code: ''
        },
        validate: (data) => {
            const errors = {};
            const patternEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
            const field = statusModal === 'initial' ? 'email' : 'code';
            if (!data[field] || data[field] === '') {
                errors[field] = statusModal === 'initial' ? t('IMPORT_GROUP.FORM.VALIDATION.EMAIL') : t('IMPORT_GROUP.FORM.VALIDATION.CODE');
            } else if (statusModal === 'initial' && !patternEmail.test(data[field])) {
                errors[field] = t('IMPORT_GROUP.FORM.VALIDATION.FAIL_EMAIL');
            }
            if (statusModal === 'initial') {
                onSucessInput(patternEmail.test(data.email))
            }
            return errors;
        },
        onSubmit: (data, actions) => {
            switch (statusModal) {
                case 'initial':
                    RespondentService.PostImportProfile(myContext.user.SubjectId, data.email)
                        .then(() => onUpdateStatus('confirm_code'))
                        .catch(err => myContext.notify6('alert' , 'Error' , ErrorParse(err)))
                        ;
                    break;
                case 'confirm_code':
                    RespondentService.PostImportProfile(myContext.user.SubjectId, data.email, data.code)
                        .then(() =>  onUpdateStatus('finish'))
                        .catch(err => myContext.notify6('alert' , 'Error' , ErrorParse(err)));
                    break;
                default:
                    navigate('/Profile', { replace: true });
                    break;
            }
        },
    });

    const isFormFieldValid = (email) => !!(formik.touched[email] && formik.errors[email]);
    const getFormErrorMessage = (name) => isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;

    return ( 
        <div className="ImportGroup active">
            <div className="ImportGroup-container">
                <div className="closeWindow" onClick={() => showImportGroup(false)}></div>
                <div>
                    <img src={importImg} alt="Import" />
                </div>
                <div>
                    {
                        statusModal !== 'initial' ?
                            <div>
                                <img src={checkIcon} alt="Check Icon" />
                            </div> :
                            <></>
                    }
                    <div>
                        <h2>
                            {
                                statusModal === 'initial'  ?
                                    t('IMPORT_GROUP.TITLE_PROFILE_REGISTERED') :
                                    (statusModal === 'confirm_code' ? t('IMPORT_GROUP.TITLE_CONFIRM_CODE') : t('IMPORT_GROUP.TITLE_THANK_YOU'))
                            }
                            </h2>
                        <p>
                            {
                                statusModal === 'initial'  ?
                                    t('IMPORT_GROUP.LABEL_PROFILE_REGISTERED') :
                                    (statusModal === 'confirm_code' ? t('IMPORT_GROUP.LABEL_CONFIRM_CODE')
                                        : t('IMPORT_GROUP.LABEL_THANK_YOU'))
                            }
                        </p>
                        <form onSubmit={formik.handleSubmit} >
                            {
                                statusModal !== 'finish' ?
                                    <span className="p-float-label">
                                {
                                    statusModal === 'initial' ?
                                        <div>
                                            <InputText autoComplete='none' delay="5000" name='email' id='email' value={formik.values.email} onChange={formik.handleChange} placeholder={t('RESPONDENT.SURVEY.FORM_SEND.EMAIL')}  className={isFormFieldValid('email') ? 'p-invalid' : ''} />
                                            <span className={!isSuccessInput ? 'check' : 'check active'}></span>
                                        </div>
                                        : (statusModal === 'confirm_code' ? <InputText type="number"  autoComplete='none' name='code' id='code' value={formik.values.code} onChange={formik.handleChange} placeholder={t('RESPONDENT.SURVEY.FORM_SEND.CODE')}  className={classNames({ 'p-invalid': isFormFieldValid('code') })} />
                                            : <></>)
                                }
                            {getFormErrorMessage(statusModal === 'initial' ? 'email' : 'code')}
                            </span> :
                                    <></>
                            }
                            <div>
                                <input type="submit" value={statusModal === 'initial' ? t('IMPORT_GROUP.BUTTON_IMPORT_PROFILE') : (statusModal === 'confirm_code' ? t('IMPORT_GROUP.BUTTON_VALIDATE_CODE') : t('IMPORT_GROUP.BUTTON_COMPLETE_PROFILE'))} className="p-button" />
                                <span>
                                    <a  onClick={() => showImportGroup(false)}>{t('IMPORT_GROUP.BUTTON_SKIP')}</a>
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );


}
